
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    // tslint:disable
    import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest, IQueryResultSettings } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
    function clubMembershipPauseResumeQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function clubMembershipPauseResumeInput (
        customerId:
            string,
            wineClubId:
            string,
            pauseResume:
            boolean
    ): IDataServiceRequest {
      const query = clubMembershipPauseResumeQuery();
      return query.createDataServiceRequestForOperation(
          'ClubMembershipPauseResume',
          true, 
            DataServiceEntities.rsmClubMembershipPauseResumeResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmClubMembershipPauseResumeResponse' },
          { 
          CustomerId: customerId,
            WineClubId: wineClubId,
            PauseResume: pauseResume
          }
      );
    }
   
    export function clubMembershipPauseResumeAsync (
        context: IContext, customerId:
            string,
            wineClubId:
            string,
            pauseResume:
            boolean
        ): AsyncResult<DataServiceEntities.IrsmClubMembershipPauseResumeResponse> {
        const request = clubMembershipPauseResumeInput(customerId, wineClubId, pauseResume);
        return callActionOrExecute<DataServiceEntities.IrsmClubMembershipPauseResumeResponse>(request, context.callerContext);
        }
      
    function clubMembershipSkipShipmentQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function clubMembershipSkipShipmentInput (
        customerId:
            string,
            wineClubId:
            string,
            skipShipment:
            boolean
    ): IDataServiceRequest {
      const query = clubMembershipSkipShipmentQuery();
      return query.createDataServiceRequestForOperation(
          'ClubMembershipSkipShipment',
          true, 
            DataServiceEntities.rsmClubMembershipSkipShipmentResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmClubMembershipSkipShipmentResponse' },
          { 
          CustomerId: customerId,
            WineClubId: wineClubId,
            SkipShipment: skipShipment
          }
      );
    }
   
    export function clubMembershipSkipShipmentAsync (
        context: IContext, customerId:
            string,
            wineClubId:
            string,
            skipShipment:
            boolean
        ): AsyncResult<DataServiceEntities.IrsmClubMembershipSkipShipmentResponse> {
        const request = clubMembershipSkipShipmentInput(customerId, wineClubId, skipShipment);
        return callActionOrExecute<DataServiceEntities.IrsmClubMembershipSkipShipmentResponse>(request, context.callerContext);
        }
      
    function clubMembershipPrimaryCardQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function clubMembershipPrimaryCardInput (
        customerId:
            string,
            wineClubId:
            string,
            creditCard:
            number
    ): IDataServiceRequest {
      const query = clubMembershipPrimaryCardQuery();
      return query.createDataServiceRequestForOperation(
          'ClubMembershipPrimaryCard',
          true, 
            DataServiceEntities.rsmClubMembershipPrimaryCardResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmClubMembershipPrimaryCardResponse' },
          { 
          CustomerId: customerId,
            WineClubId: wineClubId,
            CreditCard: creditCard
          }
      );
    }
   
    export function clubMembershipPrimaryCardAsync (
        context: IContext, customerId:
            string,
            wineClubId:
            string,
            creditCard:
            number
        ): AsyncResult<DataServiceEntities.IrsmClubMembershipPrimaryCardResponse> {
        const request = clubMembershipPrimaryCardInput(customerId, wineClubId, creditCard);
        return callActionOrExecute<DataServiceEntities.IrsmClubMembershipPrimaryCardResponse>(request, context.callerContext);
        }
      
    function clubMembershipPrimaryShipToAddressQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function clubMembershipPrimaryShipToAddressInput (
        customerId:
            string,
            wineClubId:
            string,
            shipToAddress:
            number
    ): IDataServiceRequest {
      const query = clubMembershipPrimaryShipToAddressQuery();
      return query.createDataServiceRequestForOperation(
          'ClubMembershipPrimaryShipToAddress',
          true, 
            DataServiceEntities.rsmClubMembershipPrimaryShipToAddressResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmClubMembershipPrimaryShipToAddressResponse' },
          { 
          CustomerId: customerId,
            WineClubId: wineClubId,
            ShipToAddress: shipToAddress
          }
      );
    }
   
    export function clubMembershipPrimaryShipToAddressAsync (
        context: IContext, customerId:
            string,
            wineClubId:
            string,
            shipToAddress:
            number
        ): AsyncResult<DataServiceEntities.IrsmClubMembershipPrimaryShipToAddressResponse> {
        const request = clubMembershipPrimaryShipToAddressInput(customerId, wineClubId, shipToAddress);
        return callActionOrExecute<DataServiceEntities.IrsmClubMembershipPrimaryShipToAddressResponse>(request, context.callerContext);
        }
      
    function clubMembershipUpdateQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function clubMembershipUpdateInput (
        wineClubId:
            string,
            creditCard:
            number,
            shipToAddress:
            number,
            deliveryPreference:
            string,
            pickupLocationId:
            string
    ): IDataServiceRequest {
      const query = clubMembershipUpdateQuery();
      return query.createDataServiceRequestForOperation(
          'ClubMembershipUpdate',
          true, 
            DataServiceEntities.rsmClubMembershipUpdateResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmClubMembershipUpdateResponse' },
          { 
          WineClubId: wineClubId,
            CreditCard: creditCard,
            ShipToAddress: shipToAddress,
            DeliveryPreference: deliveryPreference,
            PickupLocationId: pickupLocationId
          }
      );
    }
   
    export function clubMembershipUpdateAsync (
        context: IContext, wineClubId:
            string,
            creditCard:
            number,
            shipToAddress:
            number,
            deliveryPreference:
            string,
            pickupLocationId:
            string
        ): AsyncResult<DataServiceEntities.IrsmClubMembershipUpdateResponse> {
        const request = clubMembershipUpdateInput(wineClubId, creditCard, shipToAddress, deliveryPreference, pickupLocationId);
        return callActionOrExecute<DataServiceEntities.IrsmClubMembershipUpdateResponse>(request, context.callerContext);
        }
      
    function clubMembershipGetDataQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function clubMembershipGetDataInput (
        customerId:
            string
    ): IDataServiceRequest {
      const query = clubMembershipGetDataQuery();
      return query.createDataServiceRequestForOperation(
          'ClubMembershipGetData',
          false, 
            DataServiceEntities.rsmClubMemberMgmtGetDataResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmClubMemberMgmtGetDataResponse' },
          { 
          CustomerId: customerId
          }
      );
    }
   
    export function clubMembershipGetDataAsync (
        context: IContext, customerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmClubMemberMgmtGetDataResponse> {
        const request = clubMembershipGetDataInput(customerId);
        return callActionOrExecute<DataServiceEntities.IrsmClubMemberMgmtGetDataResponse>(request, context.callerContext);
        }
      
    function validateProgramQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function validateProgramInput (
        customerAccount:
            string,
            programId:
            string
    ): IDataServiceRequest {
      const query = validateProgramQuery();
      return query.createDataServiceRequestForOperation(
          'ValidateProgram',
          true, 
            DataServiceEntities.rsmValidateProgramResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmValidateProgramResponse' },
          { 
          CustomerAccount: customerAccount,
            ProgramId: programId
          }
      );
    }
   
    export function validateProgramAsync (
        context: IContext, customerAccount:
            string,
            programId:
            string
        ): AsyncResult<DataServiceEntities.IrsmValidateProgramResponse> {
        const request = validateProgramInput(customerAccount, programId);
        return callActionOrExecute<DataServiceEntities.IrsmValidateProgramResponse>(request, context.callerContext);
        }
      
    function verifyEmployeeQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function verifyEmployeeInput (
        customerAccount:
            string,
            employeeNumber:
            string,
            lastName:
            string,
            birthYear:
            string
    ): IDataServiceRequest {
      const query = verifyEmployeeQuery();
      return query.createDataServiceRequestForOperation(
          'VerifyEmployee',
          true, 
            DataServiceEntities.rsmVerifyEmployeeResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmVerifyEmployeeResponse' },
          { 
          CustomerAccount: customerAccount,
            EmployeeNumber: employeeNumber,
            LastName: lastName,
            BirthYear: birthYear
          }
      );
    }
   
    export function verifyEmployeeAsync (
        context: IContext, customerAccount:
            string,
            employeeNumber:
            string,
            lastName:
            string,
            birthYear:
            string
        ): AsyncResult<DataServiceEntities.IrsmVerifyEmployeeResponse> {
        const request = verifyEmployeeInput(customerAccount, employeeNumber, lastName, birthYear);
        return callActionOrExecute<DataServiceEntities.IrsmVerifyEmployeeResponse>(request, context.callerContext);
        }
      
    function friendsAndFamilyValidateProgramQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function friendsAndFamilyValidateProgramInput (
        code:
            string,
            emailListID:
            string,
            sourceID:
            string
    ): IDataServiceRequest {
      const query = friendsAndFamilyValidateProgramQuery();
      return query.createDataServiceRequestForOperation(
          'FriendsAndFamilyValidateProgram',
          true, 
            DataServiceEntities.rsmFriendsAndFamilyValidateProgramResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmFriendsAndFamilyValidateProgramResponse' },
          { 
          Code: code,
            EmailListID: emailListID,
            SourceID: sourceID
          }
      );
    }
   
    export function friendsAndFamilyValidateProgramAsync (
        context: IContext, code:
            string,
            emailListID:
            string,
            sourceID:
            string
        ): AsyncResult<DataServiceEntities.IrsmFriendsAndFamilyValidateProgramResponse> {
        const request = friendsAndFamilyValidateProgramInput(code, emailListID, sourceID);
        return callActionOrExecute<DataServiceEntities.IrsmFriendsAndFamilyValidateProgramResponse>(request, context.callerContext);
        }
      
    function friendsAndFamilyListQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function friendsAndFamilyListInput (
        
    ): IDataServiceRequest {
      const query = friendsAndFamilyListQuery();
      return query.createDataServiceRequestForOperation(
          'FriendsAndFamilyList',
          false, 
            DataServiceEntities.rsmFriendsAndFamilyListResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmFriendsAndFamilyListResponse' },
          { 
          
          }
      );
    }
   
    export function friendsAndFamilyListAsync (
        context: IContext
        ): AsyncResult<DataServiceEntities.IrsmFriendsAndFamilyListResponse> {
        const request = friendsAndFamilyListInput();
        return callActionOrExecute<DataServiceEntities.IrsmFriendsAndFamilyListResponse>(request, context.callerContext);
        }
      
    function insertMailingListQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function insertMailingListInput (
        mailingListId:
            string,
            sourceId:
            string,
            email:
            string,
            name:
            string,
            zipCode:
            string
    ): IDataServiceRequest {
      const query = insertMailingListQuery();
      return query.createDataServiceRequestForOperation(
          'InsertMailingList',
          true, 
            DataServiceEntities.rsmInsertMailingListResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmInsertMailingListResponse' },
          { 
          MailingListId: mailingListId,
            SourceId: sourceId,
            Email: email,
            Name: name,
            ZipCode: zipCode
          }
      );
    }
   
    export function insertMailingListAsync (
        context: IContext, mailingListId:
            string,
            sourceId:
            string,
            email:
            string,
            name:
            string,
            zipCode:
            string
        ): AsyncResult<DataServiceEntities.IrsmInsertMailingListResponse> {
        const request = insertMailingListInput(mailingListId, sourceId, email, name, zipCode);
        return callActionOrExecute<DataServiceEntities.IrsmInsertMailingListResponse>(request, context.callerContext);
        }
      
    function unsubscribeMailingListQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function unsubscribeMailingListInput (
        mailingListId:
            string,
            sourceId:
            string,
            email:
            string
    ): IDataServiceRequest {
      const query = unsubscribeMailingListQuery();
      return query.createDataServiceRequestForOperation(
          'UnsubscribeMailingList',
          true, 
            DataServiceEntities.rsmUnsubscribeMailingListResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmUnsubscribeMailingListResponse' },
          { 
          MailingListId: mailingListId,
            SourceId: sourceId,
            Email: email
          }
      );
    }
   
    export function unsubscribeMailingListAsync (
        context: IContext, mailingListId:
            string,
            sourceId:
            string,
            email:
            string
        ): AsyncResult<DataServiceEntities.IrsmUnsubscribeMailingListResponse> {
        const request = unsubscribeMailingListInput(mailingListId, sourceId, email);
        return callActionOrExecute<DataServiceEntities.IrsmUnsubscribeMailingListResponse>(request, context.callerContext);
        }
      
    function offerSelectionQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function offerSelectionInput (
        customerId:
            string,
            wineClubId:
            string,
            offerId:
            string
    ): IDataServiceRequest {
      const query = offerSelectionQuery();
      return query.createDataServiceRequestForOperation(
          'OfferSelection',
          true, 
            DataServiceEntities.rsmOfferSelectionsResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmOfferSelectionsResponse' },
          { 
          CustomerId: customerId,
            WineClubId: wineClubId,
            OfferId: offerId
          }
      );
    }
   
    export function offerSelectionAsync (
        context: IContext, customerId:
            string,
            wineClubId:
            string,
            offerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmOfferSelectionsResponse> {
        const request = offerSelectionInput(customerId, wineClubId, offerId);
        return callActionOrExecute<DataServiceEntities.IrsmOfferSelectionsResponse>(request, context.callerContext);
        }
      
    function getSalesPickOrdersQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function getSalesPickOrdersInput (
        queryResultSettings: IQueryResultSettings, customerId:
            string
    ): IDataServiceRequest {
      const query = getSalesPickOrdersQuery().resultSettings(queryResultSettings);
      return query.createDataServiceRequestForOperation(
          'GetSalesPickOrders',
        false, {},
          'true',
          { bypassCache: 'get', returnEntity: 'Entities.SalesOrder' },
          { 
          CustomerId: customerId
          }
      );
    }
   
    export function getSalesPickOrdersAsync (
        context: IContext, customerId:
            string
        ): AsyncResult<Entities.SalesOrder[]> {
        const request = getSalesPickOrdersInput(
          context.queryResultSettings || {}, customerId);
        return callActionOrExecute<Entities.SalesOrder[]>(request, context.callerContext);
        }
      
    function shipCompliantRequestByCartQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function shipCompliantRequestByCartInput (
        cartId:
            string
    ): IDataServiceRequest {
      const query = shipCompliantRequestByCartQuery();
      return query.createDataServiceRequestForOperation(
          'ShipCompliantRequestByCart',
          true, 
            DataServiceEntities.ShipComplianceResponseObjectExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IShipComplianceResponseObject' },
          { 
          CartId: cartId
          }
      );
    }
   
    export function shipCompliantRequestByCartAsync (
        context: IContext, cartId:
            string
        ): AsyncResult<DataServiceEntities.IShipComplianceResponseObject> {
        const request = shipCompliantRequestByCartInput(cartId);
        return callActionOrExecute<DataServiceEntities.IShipComplianceResponseObject>(request, context.callerContext);
        }
      
    function subscriptionCancelQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function subscriptionCancelInput (
        subscriptionId:
            string,
            customerId:
            string
    ): IDataServiceRequest {
      const query = subscriptionCancelQuery();
      return query.createDataServiceRequestForOperation(
          'SubscriptionCancel',
          true, 
            DataServiceEntities.rsmSubscriptionCancelResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmSubscriptionCancelResponse' },
          { 
          SubscriptionId: subscriptionId,
            CustomerId: customerId
          }
      );
    }
   
    export function subscriptionCancelAsync (
        context: IContext, subscriptionId:
            string,
            customerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmSubscriptionCancelResponse> {
        const request = subscriptionCancelInput(subscriptionId, customerId);
        return callActionOrExecute<DataServiceEntities.IrsmSubscriptionCancelResponse>(request, context.callerContext);
        }
      
    function subscriptionPauseQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function subscriptionPauseInput (
        subscriptionId:
            string,
            customerId:
            string
    ): IDataServiceRequest {
      const query = subscriptionPauseQuery();
      return query.createDataServiceRequestForOperation(
          'SubscriptionPause',
          true, 
            DataServiceEntities.rsmSubscriptionPauseResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmSubscriptionPauseResponse' },
          { 
          SubscriptionId: subscriptionId,
            CustomerId: customerId
          }
      );
    }
   
    export function subscriptionPauseAsync (
        context: IContext, subscriptionId:
            string,
            customerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmSubscriptionPauseResponse> {
        const request = subscriptionPauseInput(subscriptionId, customerId);
        return callActionOrExecute<DataServiceEntities.IrsmSubscriptionPauseResponse>(request, context.callerContext);
        }
      
    function subscriptionResumeQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function subscriptionResumeInput (
        subscriptionId:
            string,
            customerId:
            string
    ): IDataServiceRequest {
      const query = subscriptionResumeQuery();
      return query.createDataServiceRequestForOperation(
          'SubscriptionResume',
          true, 
            DataServiceEntities.rsmSubscriptionResumeResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmSubscriptionResumeResponse' },
          { 
          SubscriptionId: subscriptionId,
            CustomerId: customerId
          }
      );
    }
   
    export function subscriptionResumeAsync (
        context: IContext, subscriptionId:
            string,
            customerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmSubscriptionResumeResponse> {
        const request = subscriptionResumeInput(subscriptionId, customerId);
        return callActionOrExecute<DataServiceEntities.IrsmSubscriptionResumeResponse>(request, context.callerContext);
        }
      
    function subscriptionUpdateQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function subscriptionUpdateInput (
        subscriptionId:
            string,
            subscriptionName:
            string,
            nextOrderDate:
            string,
            deliveryPostalAddress:
            string,
            frequency:
            string,
            customerId:
            string,
            cardId:
            string
    ): IDataServiceRequest {
      const query = subscriptionUpdateQuery();
      return query.createDataServiceRequestForOperation(
          'SubscriptionUpdate',
          true, 
            DataServiceEntities.rsmSubscriptionUpdateResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmSubscriptionUpdateResponse' },
          { 
          SubscriptionId: subscriptionId,
            SubscriptionName: subscriptionName,
            NextOrderDate: nextOrderDate,
            DeliveryPostalAddress: deliveryPostalAddress,
            Frequency: frequency,
            CustomerId: customerId,
            CardId: cardId
          }
      );
    }
   
    export function subscriptionUpdateAsync (
        context: IContext, subscriptionId:
            string,
            subscriptionName:
            string,
            nextOrderDate:
            string,
            deliveryPostalAddress:
            string,
            frequency:
            string,
            customerId:
            string,
            cardId:
            string
        ): AsyncResult<DataServiceEntities.IrsmSubscriptionUpdateResponse> {
        const request = subscriptionUpdateInput(subscriptionId, subscriptionName, nextOrderDate, deliveryPostalAddress, frequency, customerId, cardId);
        return callActionOrExecute<DataServiceEntities.IrsmSubscriptionUpdateResponse>(request, context.callerContext);
        }
      
    function subscriptionCardsQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function subscriptionCardsInput (
        customerId:
            string
    ): IDataServiceRequest {
      const query = subscriptionCardsQuery();
      return query.createDataServiceRequestForOperation(
          'SubscriptionCards',
          false, 
            DataServiceEntities.rsmSubscriptionCardsResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmSubscriptionCardsResponse' },
          { 
          CustomerId: customerId
          }
      );
    }
   
    export function subscriptionCardsAsync (
        context: IContext, customerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmSubscriptionCardsResponse> {
        const request = subscriptionCardsInput(customerId);
        return callActionOrExecute<DataServiceEntities.IrsmSubscriptionCardsResponse>(request, context.callerContext);
        }
      
    function subscriptionListQuery(): DataServiceQuery {
          return new DataServiceQuery();
          }
    
    
    export function subscriptionListInput (
        customerId:
            string
    ): IDataServiceRequest {
      const query = subscriptionListQuery();
      return query.createDataServiceRequestForOperation(
          'SubscriptionList',
          false, 
            DataServiceEntities.rsmSubscriptionListResponseExtensionClass
          ,
          'false',
          { bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmSubscriptionListResponse' },
          { 
          CustomerId: customerId
          }
      );
    }
   
    export function subscriptionListAsync (
        context: IContext, customerId:
            string
        ): AsyncResult<DataServiceEntities.IrsmSubscriptionListResponse> {
        const request = subscriptionListInput(customerId);
        return callActionOrExecute<DataServiceEntities.IrsmSubscriptionListResponse>(request, context.callerContext);
        }
      
       
        // @ts-ignore
        function rSMWineClubSignUpEntityControllerQuery(wineClubId?: string): DataServiceQuery {
        const key = (wineClubId) ? { WineClubId: wineClubId } :null;
        return new DataServiceQuery("RSMWineClubSignUpEntityController", "rsmWineClubSignUpEntity", DataServiceEntities.rsmWineClubSignUpEntityExtensionClass, key);
        }

        
    export function createWineClubSignUpInput(entityData: DataServiceEntities.IrsmWineClubSignUpEntity): IDataServiceRequest {
    const query = rSMWineClubSignUpEntityControllerQuery();
    return query.createDataServiceRequestForOperation('WineClubSignUp', true, DataServiceEntities.rsmWineClubSignUpResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IrsmWineClubSignUpResponse'}, {entityData: entityData });
    }

    
    export function wineClubSignUpAsync(context: IContext, entityData: DataServiceEntities.IrsmWineClubSignUpEntity): AsyncResult<DataServiceEntities.IrsmWineClubSignUpResponse> {
    const request = createWineClubSignUpInput(entityData);
    return callActionOrExecute<DataServiceEntities.IrsmWineClubSignUpResponse>(request, context.callerContext);
    }
  